module.exports = __webpack_public_path__ + "assets/img/Inklusi.f402af37.png";